import React, {ReactNode, useEffect, useRef, useState} from "react";

interface INaverMapOption extends naver.maps.MapOptions {
  onMap?: (map: naver.maps.Map) => void
  children?: ReactNode
}

export function NaverMap(options: INaverMapOption) {

  const {onMap, children} = options

  const [map, setMap] = useState<naver.maps.Map | null>(null)

  const mapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const mapEl = mapRef.current

    if (!mapEl || map) {
      return
    }

    const m = new naver.maps.Map(mapEl, {
      // zoomControl: false,
      // zoomControlOptions: {
      //     style: naver.maps.ZoomControlStyle.LARGE,
      //     position: naver.maps.Position.TOP_RIGHT,
      // },
      // mapTypeControl: true,
      zoom: 12,
      ...options,
    })

    setMap(
      m,
    )

    if (onMap) {
      onMap(m)
    }
  }, [mapRef])

  return (
    <>
      <>
        <div
          ref={mapRef}
          className={"naver-map"}
          style={{width: "100%", height: "90vh", position: "fixed"}}
        />
        {
          React.Children.map(children, child => {
              if (!map) {
                return null
              }

              if (React.isValidElement(child)) {
                // @ts-ignore
                return React.cloneElement(child, {map});
              }
            },
          )
        }
      </>
    </>
  )
}
